import Vue from "vue";

Vue.directive("click-outside", {
  bind: function(element, binding, vnode) {
    element.clickOutsideEvent = function(event) {
      if (!(element === event.target || element.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("mousedown", element.clickOutsideEvent);
  },
  unbind: function(element) {
    document.body.removeEventListener("mousedown", element.clickOutsideEvent);
  }
});

//scroll
Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener("scroll", f);
      }
    };
    el.addEventListener("scroll", f);
  }
});
